import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { class: "w100 pad15" }
const _hoisted_3 = { class: "fl w20 pad10" }
const _hoisted_4 = { class: "fw600" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "fl w70" }
const _hoisted_7 = { class: "fl mr15" }
const _hoisted_8 = { class: "fl" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = { class: "w100 pad15" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "fl w20 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "WEB会議サービス連携"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "外部WEB会議サービスと連携させることで、日程確定時に自動でURLが発行されます。")
], -1)
const _hoisted_13 = {
  key: 0,
  class: "fl w70"
}
const _hoisted_14 = { class: "fl mr10 pointer mb10" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "fl mr10 pointer mb10" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "fl mr10 pointer mb10" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "fl mr10 pointer mb10" }
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 1,
  class: "fl w70 grey pad20"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_25 = { class: "w100 pad15" }
const _hoisted_26 = { class: "fl w20 pad10" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "登録した場所一覧", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"50px"} }, [
  /*#__PURE__*/_createTextVNode(" 調整ページ作成時に登録した場所から選択できます。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("事前に登録しておくことで、お相手に複数の場所の中から提案できるようになります。 ")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = { style: {"margin-top":"50px"} }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "fl w70"
}
const _hoisted_34 = {
  key: 0,
  class: "fs11 label label-green"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 2 }
const _hoisted_37 = {
  class: "grey",
  style: {"margin-top":"10px"}
}
const _hoisted_38 = ["src"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = { class: "w100 pad15" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "fl w20 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "場所コンバーター"),
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"50px"} }, [
    /*#__PURE__*/_createTextVNode(" 移動時間考慮時に、キーワードから場所の変換することができます。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 例："),
    /*#__PURE__*/_createElementVNode("span", { class: "fw600" }, "会議室A ⇒ 東京タワー"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" どの場所コンバーターを利用するかは公開ページで設定してください。 ")
  ]),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_42 = {
  key: 0,
  class: "fl w70"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_ScheduleViewLoader = _resolveComponent("ScheduleViewLoader")!
  const _component_LocationIcon = _resolveComponent("LocationIcon")!
  const _component_LocationConvertersList = _resolveComponent("LocationConvertersList")!
  const _component_LocationTagSettingModal = _resolveComponent("LocationTagSettingModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.loctag.id ? `編集する` : `新規作成する`), 1),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.loctag)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              id: "form",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_MdTextfieldTag, {
                  name: "場所名/住所など特定できる名前（必須）",
                  placeholder: "東京タワー17F",
                  style: {"height":"56px","min-width":"240px"},
                  class: "fl fs14",
                  value: _ctx.loctag.keyword,
                  onInputValue: _ctx.inputLocationKeyword,
                  onBlur: _ctx.checkLocationKeyword,
                  errMessage: _ctx.failedKeyword ? `場所名を入力してください。` : null,
                  required: ""
                }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "pointer centered circle_button skyblueBg fs16 rad8 ml20 mt15",
                  style: {"width":"100px","height":"50px","padding":"14px 8px"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveLoctag(_ctx.loctag)))
                }, _toDisplayString(_ctx.loctag.id ? `更新` : `作成`), 1)
              ])
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _hoisted_9
    ]),
    _hoisted_10,
    _createElementVNode("section", _hoisted_11, [
      _hoisted_12,
      (!_ctx.noshowConnectCal())
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (!_ctx.rm.can_use_zoom)
                ? _withDirectives((_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.$getAssetImageUrl(_ctx.Util.getURLFromAddress(`zoom`, `100x100`)),
                    height: 100,
                    width: 100,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickZoom && _ctx.clickZoom(...args)))
                  }, null, 8, _hoisted_15)), [
                    [_directive_tooltip, `Zoom`]
                  ])
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_ctx.rm.did_connect_google_cal && !_ctx.rm.can_use_google_meet)
                ? _withDirectives((_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.$getAssetImageUrl(_ctx.Util.getURLFromAddress(`Google Meet`, `100x100`)),
                    height: 100,
                    width: 100,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickGoogleMeet && _ctx.clickGoogleMeet(...args)))
                  }, null, 8, _hoisted_17)), [
                    [_directive_tooltip, `Google Meet`]
                  ])
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              (_ctx.rm.did_connect_ms_cal && !_ctx.rm.can_use_teams)
                ? _withDirectives((_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.$getAssetImageUrl(_ctx.Util.getURLFromAddress(`Teams`, `100x100`)),
                    height: 100,
                    width: 100,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickTeams && _ctx.clickTeams(...args)))
                  }, null, 8, _hoisted_19)), [
                    [_directive_tooltip, `Teams`]
                  ])
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              (!_ctx.rm.did_connect_ms_cal && !_ctx.rm.can_use_teams)
                ? _withDirectives((_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.$getAssetImageUrl(_ctx.Util.getURLFromAddress(`Teams`, `100x100`)),
                    height: 100,
                    width: 100,
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickOnlyTeams && _ctx.clickOnlyTeams(...args)))
                  }, null, 8, _hoisted_21)), [
                    [_directive_tooltip, `Teams（URL発行のみ）\n※ カレンダーの予定は考慮しません`]
                  ])
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_22, "連携できるWEB会議サービスがありません。")),
      _hoisted_23
    ]),
    _hoisted_24,
    _createElementVNode("section", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _hoisted_28,
        _hoisted_29,
        _createElementVNode("p", _hoisted_30, [
          _createTextVNode(" デフォルトの場所に設定をすると、調整ページ作成時に自動的にその場所が埋まります。 ※ 作成済みの調整ページに影響はありません。 "),
          _hoisted_31,
          _createElementVNode("label", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setDefault(null))),
            class: "label skyblueBorder fs11 pointer"
          }, "デフォルトの登録をはずす")
        ])
      ]),
      (!_ctx.loctags)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createVNode(_component_ScheduleViewLoader, { loadingMessage: `登録した場所情報を取得しています` })
          ]))
        : (_ctx.Util.isPresent(_ctx.loctags))
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loctags, (loctag, loctagindex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "fl centered",
                  style: {"width":"140px"},
                  key: `${loctag.id}_${loctagindex}`
                }, [
                  (_ctx.defaultLoctag && _ctx.defaultLoctag.id == loctag.id)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_34, "デフォルト"))
                    : (_openBlock(), _createElementBlock("label", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.setDefault(loctag)),
                        class: "label skyblueBorder fs11 pointer"
                      }, "デフォルトに設定", 8, _hoisted_35)),
                  _withDirectives(_createVNode(_component_LocationIcon, {
                    width: 130,
                    totalHeight: 180,
                    loctag: loctag,
                    canDelete: true,
                    useLocationIcon: true,
                    class: _normalizeClass(`mb5`),
                    onDeleteLocation: _ctx.deleteLocation,
                    onClickLocation: ($event: any) => (_ctx.clickLoctag(loctag))
                  }, null, 8, ["loctag", "onDeleteLocation", "onClickLocation"]), [
                    [
                      _directive_tooltip,
                      loctag.location_type == `online_oauth` ? `${loctag.private_memo}` : null,
                      void 0,
                      { bottom: true }
                    ]
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createTextVNode(" 場所が登録されていません。 "),
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                  width: "24",
                  height: "24",
                  style: {"margin-top":"-8px"}
                }, null, 8, _hoisted_38)
              ])
            ]))
    ]),
    _hoisted_39,
    _createElementVNode("section", _hoisted_40, [
      _hoisted_41,
      (_ctx.Util.isPresent(_ctx.loctags))
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createVNode(_component_LocationConvertersList, { canEdit: true })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_LocationTagSettingModal, {
      edittingLoctag: _ctx.edittingLoctag,
      saveLoctag: _ctx.saveLoctag
    }, null, 8, ["edittingLoctag", "saveLoctag"])
  ]))
}